import { ReactNode } from 'react';

const SkillsLayout = ({ children }: { children: ReactNode }) => {
  return <>{children}</>;
};

export default [SkillsLayout];
